// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".benefit-button{background-image:linear-gradient(90deg,#3373ff,#0050ff);border:none;border-radius:.22rem;color:#fff;display:block;font-size:.16rem;height:.4rem;line-height:.4rem;margin:0 .16rem .21rem;text-align:center;-webkit-text-decoration:none;text-decoration:none}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
